/**
 * Tutar formatlama yardımcıları.
 * Fatura/teklif/sipariş formlarındaki tutarlar binlik ayraçla (tr-TR) gösterilir,
 * ör. 1234567.89 -> "1.234.567,89". Böylece 100 bin ile 1 milyon ayırt edilebilir.
 * parseAmountInput ise kullanıcının her iki formatta da ("1.234,50", "1234.50",
 * "1234,5") yazabildiği girişleri güvenle sayıya çevirir.
 */

const trFormatter = new Intl.NumberFormat('tr-TR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Sayıyı tr-TR binlik ayraçlı, 2 ondalıklı metne çevirir. */
export function formatAmount(value: number | null | undefined): string {
  const n = typeof value === 'number' && !isNaN(value) ? value : 0;
  return trFormatter.format(n);
}

/**
 * Kullanıcı girişini sayıya çevirir.
 * Kurallar:
 * - Hem nokta hem virgül varsa: sona yakın olan ondalık ayraçtır, diğeri binlik.
 * - Sadece virgül: tekse ondalık ("1234,5"), birden çoksa binlik ("1,234,567").
 * - Sadece nokta: tekse ondalık ("1234.5" - eski davranış korunur),
 *   birden çoksa binlik ("1.234.567").
 * Geçersiz girişte NaN döner.
 */
export function parseAmountInput(raw: string): number {
  const s = (raw ?? '').trim();
  if (!s) return NaN;

  const lastComma = s.lastIndexOf(',');
  const lastDot = s.lastIndexOf('.');
  let normalized: string;

  if (lastComma >= 0 && lastDot >= 0) {
    normalized = lastComma > lastDot
      ? s.replace(/\./g, '').replace(',', '.')
      : s.replace(/,/g, '');
  } else if (lastComma >= 0) {
    normalized = s.split(',').length > 2 ? s.replace(/,/g, '') : s.replace(',', '.');
  } else if (lastDot >= 0) {
    normalized = s.split('.').length > 2 ? s.replace(/\./g, '') : s;
  } else {
    normalized = s;
  }

  return parseFloat(normalized.replace(/[^\d.-]/g, ''));
}
